import type {
  CourseOrganization,
  CriticalActionEvent,
  DomainOfExcellence,
  Entity,
  EntityDict,
  LinkedPlayerBuildsSettings,
  User,
  UserSlim
} from '@webapp2/shared/model'
import { reactive } from 'vue'
import type { MultiplayerSession, PermissionGroup } from '../state'

export const adminState = reactive({
  courses: <EntityDict<AdminCourse>>{},
  courseOrganizations: <EntityDict<CourseOrganization>>{},
  multiplayerSessions: <EntityDict<MultiplayerSession>>{},
  organizationSlims: <EntityDict<OrganizationSlim>>{},
  permissionGroups: <EntityDict<PermissionGroup>>{},
  playerTechniqueSlims: <EntityDict<EntitySlim>>{},
  userSlims: <EntityDict<UserSlim>>{},
  users: <EntityDict<User>>{},
  playerRuns: <EntityDict<AdminPlayerRun>>{},
  linkedPlayerBuildsSettings: <EntityDict<LinkedPlayerBuildsSettings>>{}
})

export type EntitySlim = Entity & { name: string }

export type AdminCourse = Entity & {
  name: string
  techniqueId: string
  linkedModuleBuildsId?: string
  healthStreamCourseId?: string
  isArchived?: boolean
}

export type OrganizationSlim = EntitySlim & {
  healthStreamOrganizationId?: string
}

export type Stage = {
  id: string
  name: string
  criticalActions: CriticalAction[]
}

type CriticalAction = {
  id: string
  description: string
  criticalSubActions: CriticalSubAction[] | null
  domainsOfExcellence: DomainOfExcellence[]
}

type CriticalSubAction = {
  id: string
  description: string
  supplySelectionItems: SupplySelectionItem[] | null
}

type SupplySelectionItem = {
  id: string
  name: string
  correct: boolean
  category: SupplyCategory
}

export type SupplyCategory = 'Correct' | 'IncorrectVariant' | 'MiscDecoy'

export type AdminPlayerRun = Entity & {
  id: string
  runLogId: string
  date: string
  userId: string
  organizationId: string
  linkedModuleBuildsId?: string
  techniqueId: string
  linkedPlayerBuildsId?: string
  multiplayerSessionId?: string
  isTest: boolean
  completed: boolean
  errorWhileProcessing?: string
  level?: number
  hintsUsed?: number
  time: number
  isOsso: boolean
  ranTutorial: boolean
  isTutorialRun: boolean
  courseId?: string
  score?: number
  criticalActions: CriticalActionEvent[]
  hints: HintEvent[]
  isEmbedded: boolean
}

export type HintEvent = {
  id: string
  criticalAction: string
}

export type AdminState = typeof adminState
